import script from "./ArticleTemplateEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleTemplateEditor.vue?vue&type=script&setup=true&lang=js"

import "./ArticleTemplateEditor.vue?vue&type=style&index=0&id=7ba70d9d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ba70d9d"]])

export default __exports__